<div class="p-6">
  <h2 class="text-xl font-semibold mb-4">{{ 'translation.editTranslations' | translate }}</h2>

  <form [formGroup]="form" class="grid grid-cols-2 gap-4">
    @for (code of languageCodes(); track code; let isFirst = $first) {
      <ctr-form-field [label]="code" [class.col-span-2]="isFirst">
        <textarea ctrInput [formControlName]="code" rows="2" class="resize-none"></textarea>
      </ctr-form-field>
    }
  </form>

  <div class="flex justify-end gap-3 mt-6">
    <button ctrStrokedButton type="button" [load]="isTranslating()" (click)="translate()">
      {{ 'translation.translate' | translate }}
    </button>
    <button ctrButton type="button" (click)="confirm()" [load]="isTranslating()">
      {{ 'ui.confirmDialog.confirm' | translate }}
    </button>
  </div>
</div>
